<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div v-if="customerId">
    <v-icon v-if="layerswitcherVisible" :class="layericonHideStyle" @click="toggleLayerswitcher()">
      mdi-chevron-up
    </v-icon>

    <v-btn v-else :class="layericonHideStyle" @click="toggleLayerswitcher()" class="layericon" fab small>
      <v-icon>
        mdi-layers
      </v-icon>
    </v-btn>

    <v-card id=layerlist :class="layerswitcherStyle">
      <MapLayerSwitcher class="my-1" v-show="layerswitcherVisible" ref="layerswitcher" :map="map" :selection="selection"
        :filter="filter" :allnoneButtons="false" v-bind:isDisabled="false" v-on:selectLayerForEdit="selectLayerForEdit"
        v-on:editLayer="onEditLayer" />

      <v-card-actions v-show="layerswitcherVisible" v-if="map.task && subscriptionGroup != '__SUB_CIVIL_ROADPROFILER'">

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">

            <div v-on="on" class="d-inline-block">
              <v-btn :loading="loading" text v-on="on"
                :disabled="selectedLayersForEdit.length < 1 || !$auth.functionGroups.includes(5)"
                @click="updateDxf('keeplayers')">
                <v-icon>
                  mdi-file-multiple
                </v-icon>
              </v-btn>
            </div>

          </template>
          <span v-if="$auth.functionGroups.includes(5)">{{ language.t('LayerSwitcher.keeplayers') }}</span>
          <span v-else="!$auth.functionGroups.includes(5)">{{ language.t("App.invalidSubscription") }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="d-inline-block">
              <v-btn :loading="loading"
                :disabled="selectedLayersForEdit.length < 1 || !$auth.functionGroups.includes(5)" text
                @click="updateDxf('dellayers')">
                <v-icon>
                  mdi-file-edit
                </v-icon>
              </v-btn>
            </div>
          </template>
          <span v-if="$auth.functionGroups.includes(5)">{{ language.t('LayerSwitcher.dellayers') }}</span>
          <span v-else="!$auth.functionGroups.includes(5)">{{ language.t("App.invalidSubscription") }}</span>
        </v-tooltip>


        <!-- <v-tooltip bottom v-if="$auth.functionGroups.includes(1) && subscriptionGroup">
          <template v-slot:activator="{ on, attrs }">
            <v-btn :loading="loading" text v-bind="attrs" v-on="on" :color="state ? 'green' : 'black'"
              @click="uploadDXF()">
              <v-icon>
                mdi-file-upload-outline
              </v-icon>
            </v-btn>
          </template>
          <span>UPLOADDXF</span>
        </v-tooltip> -->

        <v-tooltip bottom v-if="$auth.functionGroups.includes(1) && subscriptionGroup">
          <template v-slot:activator="{ on, attrs }">
            <v-btn :loading="loading" text v-bind="attrs" v-on="on" :color="map.getLinelogState ? 'green' : 'black'"
              @click="dxfToLinelog()">
              <v-icon>
                mdi-chart-line-variant
              </v-icon>
            </v-btn>
          </template>
          <span>DXFTOLINELOG</span>
        </v-tooltip>

      </v-card-actions>
    </v-card>
    <v-btn v-show="this.$vuetify.breakpoint.xsOnly" class="layericon" @click="toggleLayerswitcher()" fab small>
      <v-icon>
        mdi-layers
      </v-icon>
    </v-btn>

    <v-icon :class="layericonStyle" large v-show="layerswitcherVisible && $auth.subscription !== '__SUB_CIVIL_VECTOR'"
      @click="toggleLayerswitcher()">
      mdi-close</v-icon>

    <v-btn v-show="!layerswitcherVisible"
      :class="$auth.subscription !== '__SUB_CIVIL_VECTOR' ? layericonStyle : layericonStyleVector"
      @click="toggleLayerswitcher()" fab small>
      <v-icon>
        mdi-layers
      </v-icon>
    </v-btn>

    <v-dialog v-model="editLayerDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Edit motionplan</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="newLayerName"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :disabled="loading" text @click="editLayerDialog = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="loading" text @click="deleteLayerDialog = true">
            Delete
          </v-btn>
          <v-btn color="primary" :loading="loading" text @click="onSaveEditLayer">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteLayerDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Weet je het zeker?</span>
        </v-card-title>
      <v-card-text>
          <span>Weet je zeker dat je het motionplan wilt verwijderen?</span>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :disabled="loading" text @click="deleteLayerDialog = false">
            Close
          </v-btn>
             <v-spacer></v-spacer>
         <v-btn color="primary" :loading="loading" text @click="onDeleteLayer">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>


<script>
import MapLayerSwitcher from "../webcomponents/vueComponents/MapLayerSwitcher.vue";

export default {
  name: "MapLayerSwitcherFloating",
  data() {
    return {
      layerswitcherVisible: this.$vuetify.breakpoint.xsOnly ? false : true,

      selectedLayersForEdit: [],
      LayersForEdit: [],
      parentForEdit: null,

      loading: false,
      state: false,

      editLayerDialog: false,
      deleteLayerDialog: false,
      dxfFileId: 0,
      newLayerName: "",
    };
  },
  components: {
    MapLayerSwitcher,
  },
  props: {
    /* Map.vue reference */
    map: {
      required: true,
    },
    /* for civil there is the posibility to have an extra select box for some layers */
    selection: {
      required: false,
      default: false,
    },
    /* option to filter for only specific layers, used on the robot to filter for only dxf layers
            if filter is array: filter out top level layers that do not match
            if filter is string: only show child layers of this layer */
    filter: {
      required: false,
      default: null,
    },
    subscriptionGroup: {
      required: false,
      default: null,
    }
  },
  computed: {
    customerId() {
      return this.$auth.customerId;
    },
    subscription() {
      return this.$auth.subscription;
    },
    layerswitcherStyle: function () {
      return {
        floating: !this.$vuetify.breakpoint.xsOnly,
        popup: this.$vuetify.breakpoint.xsOnly,
      };
    },
    layericonHideStyle: function () {
      return {
        hidden: this.$vuetify.breakpoint.xsOnly,
        layerhideicon: !this.$vuetify.breakpoint.xsOnly && this.layerswitcherVisible,
        layershowicon: !this.$vuetify.breakpoint.xsOnly && !this.layerswitcherVisible,
      };
    },
    layericonStyle: function () {
      return {
        hidden: !this.$vuetify.breakpoint.xsOnly,
        layericon: this.$vuetify.breakpoint.xsOnly,
      };
    },
    layericonStyleVector: function () {
      return {
        hidden: !this.$vuetify.breakpoint.xsOnly,
        layericonvector: this.$vuetify.breakpoint.xsOnly,
      };
    },
    layericonCloseStyle: function () {
      return {
        hidden: !this.$vuetify.breakpoint.xsOnly,
        layercloseicon: this.$vuetify.breakpoint.xsOnly,
      };
    },
  },
  watch: {},
  mounted: function () {
    if (this.customerId) this.update();
  },
  watch: {},
  methods: {
    onEditLayer(layerId) {
      this.dxfFileId = layerId.split("-").pop()
      this.newLayerName = ""
      this.editLayerDialog = true;
    },
    onSaveEditLayer() {
      if (!this.newLayerName) return;

      this.loading = true
      let data = new FormData();
      data.set("name", this.newLayerName);
      this.$axios.post(route("api.tasks.renamemotionplan", [this.map.task.taskId, this.dxfFileId]), data).then(res => {
        console.log(res)
        this.editLayerDialog = false;
        this.reloadTask(res.data.taskId)
        this.loading = false
      })
    },
    onDeleteLayer() {
      this.loading = true

      this.$axios.post(route("api.tasks.deletemotionplan", [this.map.task.taskId, this.dxfFileId])).then(res => {
        console.log(res)
        this.editLayerDialog = false;
        this.deleteLayerDialog = false;
        this.reloadTask(res.data.taskId)
        this.loading = false
      })
    },
    uploadDXF() {
      this.$emit("openUploadDXF");
    },
    dxfToLinelog() {
      this.$emit("dxfToLinelog");
    },
    setActiveLayer(id) {
      this.$refs.layerswitcher.setActiveLayer(id);
    },
    reloadTask(taskId) {
      this.$emit("closeTask");
      this.$emit("openTask", taskId);
    },
    update() {
      console.log("update layerswitcher");
      this.selectedLayersForEdit = [];
      this.$nextTick(() => {
        this.$refs.layerswitcher.getLayersArray();
      });
    },
    showLayers() {
      this.layerswitcherVisible = true;
    },
    hideLayers() {
      this.layerswitcherVisible = false;
    },
    toggleLayerswitcher() {
      this.layerswitcherVisible = !this.layerswitcherVisible;
      if (this.layerswitcherVisible && this.$vuetify.breakpoint.xsOnly) {
        this.$emit("changePopup", "layerswitcher");
      }
      console.log(this.layerswitcherVisible);
    },
    selectLayerForEdit(layer) {
      if (layer.children.length > 0) {
        if (layer.checkBoxValue) {
          layer.children.forEach(childElement => {
            childElement.checkBoxValue = true;
            let index = this.selectedLayersForEdit.indexOf(childElement.name);
            if (index == -1) {
              this.selectedLayersForEdit.push(childElement.name);
              this.colorSelectedLayer(childElement.name, true);
            }
          })
        } else {
          layer.children.forEach(childElement => {
            childElement.checkBoxValue = false;
            this.colorSelectedLayer(childElement.name, false);
          })
          this.selectedLayersForEdit = [];
        }
      } else {
        if (layer.checkBoxValue) {
          this.selectedLayersForEdit.push(layer.name);
          this.colorSelectedLayer(layer.name, true);
        } else {
          let index = this.selectedLayersForEdit.indexOf(layer.name);
          if (index !== -1) this.selectedLayersForEdit.splice(index, 1);
          this.colorSelectedLayer(layer.name, false);

          //deselect parent
        }
      }
    },
    colorSelectedLayer(layer, select) {
      this.map.colorSelectedLayer(layer, select);
    },
    updateDxf(option) {
      // if no task selected return
      if (!this.map.task) return;
      this.loading = true;
      this.$axios
        .post(route("api.tasks.dxfaction", this.map.task.taskId), { layers: this.selectedLayersForEdit.toString(), option: option })
        .then((res) => {
          console.log(res);
          setTimeout(() => {
            this.checkTask(this.map.task.taskId);
          }, 2000);
        })
        .catch((e) => {
          reloadTask();
        });
    },
    checkTask(taskId) {
      this.$axios.get(route("api.tasks.dxfactionstatus", taskId)).then((res) => {
        if (res.data.finished != null) {
          console.log("task finished");
          //get task
          this.getNewTask(this.map.task.taskId);

          //reload task
        } else {
          console.log("task not finished");
          //loading = true;
          // keep checking for result
          setTimeout(this.checkTask, 10000, taskId);
        }
      });
    },
    getNewTask(taskId) {
      console.log("reloadTask: " + taskId);
      this.$axios.get(route("api.task", taskId)).then((res) => {
        this.loading = false;
        Object.assign(this.$data, this.$options.data.apply(this));
        this.reloadTask(res.data)
      });
    }
  },
};
</script>

<style scoped>
#layerlist {
  z-index: 75;
  width: 300px;
}

.floating {
  position: absolute;
  top: 14px;
  right: 11px;
}

.popup {
  position: absolute;
  max-height: 80vh;
  width: 100vw !important;
  top: 0px;
  right: 0px;
}

.hidden {
  display: none;
}

.layericon {
  z-index: 70;
  position: absolute;
  bottom: 10px;
  right: 55px;
}

.layericonvector {
  z-index: 70;
  position: absolute;
  bottom: 10px;
  right: 18px;
}

.layercloseicon {
  z-index: 76;
  position: absolute;
  top: 10px;
  right: 10px;
}

.layerhideicon {
  z-index: 76;
  position: absolute;
  top: 30px;
  right: 28px;
}

.layershowicon {
  z-index: 76;
  position: absolute;
  top: 22px;
  right: 20px;
}
</style>
<!-- <style>
/*TODO: this is not working yet */
.popup:first-child {
  max-height: none;
  height: 5000px;
  width: 100%;
}
</style> -->